// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Wire enum for the server "SelfServBuildReason" type (members + integer values are the
// wire contract). The hand facade in app/common re-exports this and hosts any
// non-derivable helpers; see design/wiki/wire-schemas.md.
export enum SelfServBuildReason {
  Unknown = 0,
  Manual = 1,
  VariableChange = 2,
  SnippetChange = 3,
  TreeChange = 4,
  ConfigChange = 5,
  TeamChange = 6,
  Scheduled = 7,
}
